import { rem } from 'polished';
import React from 'react';
import styled from 'styled-components';

import { Spinner } from '@vimeo/bokeh';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${rem(100)};
`;

const LoadingPage = () => (
  <Wrapper>
    <Spinner size="xl" />
  </Wrapper>
);

export default LoadingPage;
